










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { User } from '../services/auth';

@Component
export default class TheHeader extends Vue {
  @Prop() isAuthenticated!: boolean;
  @Prop() currentUser!: User;
}
